import router, { asyncRoutes } from '@/router'
import { MasterlinkRoleServiceProxy, TenantAppServiceProxy } from '@/service-proxies/app-v2/system.service-proxies'
import { WarehouseAreaServiceProxy } from '@/service-proxies/app-v2/warehouse.service-proxies'
import { materialRouter } from '../../router/modules/material'
import { ProductionPlanTypeServiceProxy } from '@/service-proxies/app-v2/coproduction.service-proxies'
import store from '@/store'
const masterlinkRoleService = new MasterlinkRoleServiceProxy()
const warehouseAreaServiceProxy = new WarehouseAreaServiceProxy()
const tenantAppServiceProxy = new TenantAppServiceProxy()
const pptsp = new ProductionPlanTypeServiceProxy();
let asyncRoutesFlat = [] as any

// 把本地创建的路由拉平
function parseRouter(routes: any) {
  routes.forEach((route: any) => {
    asyncRoutesFlat.push({
      path: route.path,
      component: route.component,
    })
    if (route.children && route.children.length > 0) {
      parseRouter(route.children)
    }
  })
}
// 返回给vue动态绑定的路由
function filterAsyncRoutes(routes: any) {
  const res = [] as any
  routes.forEach((route: any) => {
    route.path = route.data.path
    route = handleRoute(route)
    res.push(route)
  })
  return res
}

// 给后台返回的路由绑上component
function handleRoute(route: any) {
  asyncRoutesFlat.forEach((aRouter: any) => {
    if (route.path === aRouter.path) {
      route.component = aRouter.component
      if (route.children) {
        route.children.forEach((_route: any) => {
          _route.path = _route.data.path
          _route = handleRoute(_route)
        })
      }
    }
  })
  return route
}

const state = {
  appRoutes: [],
  buttons: [],
  routeDict: {},
  wmsRoutes: [],
  materialRoutes: [],
  appRouteMap:[],
  statisticalRoutes: []
} 

function getPath(routes,arr = []){
  routes.forEach(item => {
    if(item.path){
      arr.push({path:item.path})
    }
    if(item.children){
      getPath(item.children,arr)
    }
  })
}

const mutations = {
  SET_APP_ROUTE_MAP(state: any, payload: any){
    let findItem = state.appRouteMap.find(item => {
      return item.appCode == payload.appCode
    })
    if(findItem){
      return;
    }else{
      let routes = [];
      getPath(payload.routes,routes);
      state.appRouteMap.push({
        appCode:payload.appCode,
        appName:payload.appName,
        routes:routes
      })
    }
  },
  SET_ROUTES: (state: any, routes: any) => {
    state.appRoutes = routes
    function helper(routes, dict = {}) {
      const queue = []
      queue.push(routes[0])
      while (queue.length) {
        const curr = queue.pop()
        if (dict[curr.data.path]) continue
        if (curr.children) {
          queue.push(...curr.children)
          continue
        }
        if (curr.data.code) {
          dict[curr.data.path] = curr.data.code
        }
      }
    }
    if (routes.length) {
      helper(routes, state.routeDict)
    }
  },
  SET_BUTTONS: (state: any, buttons: any) => {
    state.buttons = buttons
  },
  SET_WMSROUTES: (state: any, wmsRoutes: any) => {
    state.wmsRoutes = wmsRoutes
  },
  SET_MATERIAL_ROUTERS: (state: any, materialRoutes: []) => {
    state.materialRoutes = materialRoutes
  },
  SET_STATISTICAL_ROUTES: (state: any, statisticalRoutes: []) => {
    state.statisticalRoutes = statisticalRoutes
  },

}

const  actions = {
   getRouteAppCode({ commit,state },routePath){
    let currRouteData;
    if(state.appRouteMap.length){
      state.appRouteMap.some(async item => {
        let findRoute = item.routes.find(route => route.path == routePath);
        if(findRoute){
          let appCode = item.appCode

          currRouteData = {
            appCode: appCode,
            appName:item.appName,
            route:findRoute
          }
          return true;
        }
      })
    }
    return currRouteData;
  },
  generateRoutes({ commit }: any, appcode: string) {
    asyncRoutesFlat = []
    parseRouter(asyncRoutes)
    return new Promise(resolve => {
      const edition = 1
      const kind = 3
      masterlinkRoleService.getAvailableMenus(appcode, edition, kind).then(res => {
        if(appcode == 'coproduction') {

          pptsp.getProductionPlanTypeInfo().then((res) => {
            console.log(res,'计划类型');
            localStorage.setItem('coproduction',JSON.stringify(res))
          })
        }
        // 多添加一层app
        const tempData = res.data.treeNodeList as [any]
        console.log(tempData)
        // 有效的路由
        // 过滤掉 后台有的前端没有的路由，防止报错
        const validData = []
        tempData.forEach(temp => {
          if (temp.children && temp.children.length > 0) {
            const tempChildren = []
            temp.children.forEach(child => {
              if (asyncRoutesFlat.findIndex(re => re.path === child.data.path) > -1) {
                tempChildren.push(child)
              }
            })
            temp.children = tempChildren
            validData.push(temp)
          } else {
            if (asyncRoutesFlat.findIndex(re => re.path === temp.data.path) > -1) {
              validData.push(temp)
            }
            // if(temp.data.path == '/material/basics/statisticalReport') {
            //   validData.push(temp)
            // }
          }
        })
        if (validData.length === 0) {
          store.dispatch('user/logout').then(() => {
            router.push('/login')
          })       
          return
          // router.push('/login') 
        } 
        const temp = [
          {
            children: validData,
            data: {
              path: validData[0].data.parentPath,
            },
          },
        ]
        const accessedRoutes = filterAsyncRoutes(temp)
        commit('app/SET_APP', appcode, { root: true })
        resolve(accessedRoutes)
      })
    })
  },
  async setButtons({ commit }: any) {
    const res = await masterlinkRoleService.getIdsOfAvailableElements()
    commit('SET_BUTTONS', res.data.codeList)
  },
  async setWmsRouter({ commit }: any) {
    const res = await warehouseAreaServiceProxy.listWarehouseArea('')
    commit('SET_WMSROUTES', res)
    const res1 = await masterlinkRoleService.getAvailableMenus('material', 1, 1)
    let copy = JSON.parse(JSON.stringify(res1.data.treeNodeList))  
    let statisticalArr = []
    copy.forEach((x) => {
      if(x.title != '物料区') {
        statisticalArr.push(x)
      }
    })
    commit('SET_STATISTICAL_ROUTES', statisticalArr)

    let materialRouterList  = []
    if (res1.data && res1.data && res1.data.treeNodeList && res1.data.treeNodeList[0] && res1.data.treeNodeList[0].children){
      materialRouter.forEach(mrouter => {
        let flag = false
        res1.data.treeNodeList[0].children.forEach(router => {
          if (router.data.path === mrouter.path) {
            flag = true
          }
        })
        if (flag) {
          materialRouterList.push(mrouter)
        }
      })
    }
    commit('SET_MATERIAL_ROUTERS', materialRouterList)
    return materialRouterList;
  },
}

export default {
  namespaced: true,
  state,
  mutations,
  actions,
}
